import { h, Component } from 'preact'
import PostAPI from '../api/PostAPI'
import Posts from '../components/Posts'
import LoadMorePosts from '../components/LoadMorePosts'
// Tell Babel to transform JSX into h() calls:
/** @jsx h */

class App extends Component {

  constructor(props) {
    super(props);
    this.state = {
      allPosts: [],
      posts: [],
      count: 6,
      offset: 0,
      totalAmountPosts: null,
      isLoading: true,
      error: false,
    }

    this.handleLoadMore = this.handleLoadMore.bind(this)
    this.increasePosts = this.increasePosts.bind(this)
  }

  componentDidMount() {
    this.fetchPosts()
  }

  fetchPosts() {
    this.setState({ isLoading: true })

    let promises = PostAPI.all()

    Promise.all(promises)
    .then(results => {
      // flatten results into one array
      let data = [].concat.apply([], results)
      // sort data by date
      data.sort(this.latestFirst)
      // get the first few projects
      let limitedData = data.slice(0, this.state.count)

      window.setTimeout(() => {
        this.setState({
          allPosts: data,
          posts: limitedData,
          totalAmountPosts: data.length,
          isLoading: false
        })
      }, 500)
    })
    .catch(error => {
      this.setState({
        error: true,
        isLoading: false
      })
    })
  }

  latestFirst(a,b) {
    if (a.date > b.date)
      return -1;
    if (a.date < b.date)
      return 1;
    return 0;
  }

  increasePosts() {
    this.setState({ isLoading: true })

    // grab more posts
    let tail = this.state.offset + this.state.count
    let newPosts = this.state.allPosts.slice(this.state.offset, tail)

    window.setTimeout(() => {
      this.setState({
        posts: [...this.state.posts, ...newPosts],
        isLoading: false
      })
    }, 500)
  }

  handleLoadMore() {
    this.setState( (prevState) => {
      return {
        offset: prevState.offset + this.state.count
      }
    }, this.increasePosts )
  }

  render() {
    return (
      <div className="c-projects-news-app">

        <Posts
          posts={this.state.posts}
          loading={this.state.isLoading}
          error={this.state.error}
        />

        <LoadMorePosts
          onLoadMore={this.handleLoadMore}
          nrShowing={this.state.posts.length}
          nrAll={this.state.totalAmountPosts}
          loading={this.state.isLoading}
          title="Toon meer projecten"
        />

      </div>
    )
  }
}

export default App



// WEBPACK FOOTER //
// ./src/js/projectsnews/containers/App.js